export function buildCommunityOutreachTOC() {
    var toc = document.getElementById('community-outreach-toc');
    if (!toc) {
        return;
    }
    var tocHTML = '<ol>';
    document.getElementById('community-outreach-content').querySelectorAll('h2').forEach(function (elt) {
        if (elt.id) {
            tocHTML += "<li><a href=\"#".concat(elt.id, "\">").concat(elt.textContent, "</a></li>");
        }
    });
    toc.innerHTML = "".concat(tocHTML, "</ol>");
}
